export default [
  {
    path: '/register',
    name: 'register',
    meta: { title: '欢迎加入就业队长' },
    component: () => import('../../views/register/register')
  },
  {
    path: '/register-ok',
    name: 'register-ok',
    meta: { title: '注册成功' },
    component: () => import('../../views/register/register-ok')
  },
  {
    path: '/register-update',
    name: 'register-update',
    meta: { title: '下载更新' },
    component: () => import('../../views/register/register-update')
  }
];
